/**
 * Ultra-Minimal Card Component
 * Pure white background, thin border, no shadow
 */

interface CardProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
}

export function Card({ 
  children,
  title,
  className = ''
}: CardProps) {
  return (
    <div className={`bg-white border border-gray-200 rounded-lg p-4 ${className}`}>
      {title && <h3 className="text-base font-semibold text-[#0D9488] mb-3">{title}</h3>}
      {children}
    </div>
  );
}
